import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { displayNameOf } from '../../helpers/displayName';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import config from '../../config';

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";

const ProfileDropdown = () => {

    const profiledropdownData = createSelector(
        (state) => state.Profile,
        (state) => ({
            user: state.user
        })
      );
    // Inside your component
    const {user} = useSelector(profiledropdownData);

    const [userName, setUserName] = useState("Admin");
    const [userAvatar, setUserAvatar] = useState(null); // Start with null to show letter avatar by default
    const [userEmail, setUserEmail] = useState("");
    const [isGoogleUser, setIsGoogleUser] = useState(false);

    // Generate avatar letter for users without profile picture
    const getAvatarLetter = (name) => {
        if (!name) return "A";
        return name.charAt(0).toUpperCase();
    };

    useEffect(() => {
        if (localStorage.getItem("authUser")) {
            try {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                
                // Set user name
                // display_name wins; the rest is the Google account name, which
                // the OAuth sync rewrites on every login.
                const displayName = displayNameOf(obj) || "Admin";
                
                setUserName(displayName);
                setUserEmail(obj.email || "");
                setIsGoogleUser(obj.provider === 'google');
                
                // Set avatar - use proxy endpoint for Google avatars
                
                if (obj.avatar_url && obj.provider === 'google' && obj.id) {
                    // Use our backend avatar proxy endpoint for Google avatars
                    const proxyAvatarUrl = `${config.api.API_URL}/api/avatar/${obj.id}`;
                    setUserAvatar(proxyAvatarUrl);
                } else if (obj.avatar_url) {
                    setUserAvatar(obj.avatar_url);
                } else {
                    setUserAvatar(null); // Will show letter avatar
                }
                
            } catch (error) {
                console.error('Error parsing authUser:', error);
                setUserName("Admin");
                setUserAvatar(avatar1);
            }
        }
    }, [user]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    
    // Debug current state - enable this to see what's happening
    
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        {userAvatar ? (
                            <img 
                                className="rounded-circle header-profile-user" 
                                src={userAvatar}
                                alt="Header Avatar"
                                onError={(e) => {
                                    console.error('Failed to load avatar image:', userAvatar);
                                    console.error('Image error event:', e);
                                    
                                    // If this was a proxy URL that failed, try the direct Google URL as fallback
                                    if (userAvatar && userAvatar.includes('/api/avatar/') && sessionStorage.getItem("authUser")) {
                                        try {
                                            const obj = JSON.parse(sessionStorage.getItem("authUser"));
                                            if (obj.avatar_url && obj.provider === 'google') {
                                                setUserAvatar(obj.avatar_url);
                                                return;
                                            }
                                        } catch (err) {
                                            console.error('Error parsing authUser for fallback:', err);
                                        }
                                    }
                                    
                                    // Default fallback to letter avatar
                                    setUserAvatar(null);
                                }}
                                onLoad={() => {
                                }}
                                style={{ width: '32px', height: '32px' }}
                            />
                        ) : null}
                        {!userAvatar && (
                            <div 
                                className="rounded-circle header-profile-user d-flex align-items-center justify-content-center text-white fw-bold"
                                style={{
                                    width: '32px',
                                    height: '32px',
                                    backgroundColor: isGoogleUser ? '#4285f4' : '#6c757d',
                                    fontSize: '14px'
                                }}
                            >
                                {(() => {
                                    const letter = getAvatarLetter(userName);
                                    return letter;
                                })()}
                            </div>
                        )}
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                {userName}
                            </span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                                {isGoogleUser ? 'Google Account' : 'Local Account'}
                            </span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                    <DropdownItem className='p-0'>
                        <Link to= "/profile" className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profile</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to= "/my-research" className="dropdown-item">
                            <i className="mdi mdi-robot-outline text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">My Research</span>
                        </Link>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0'>
                        <Link to= "/logout" className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Logout</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;